<template>
  <div class="users content-container flex-column">
    <div class="content-wrap">
      <div class="d-flex users-section-container no-content">
        <div class="users-section"></div>
        <div class="content-wrap">
          <TopMenu />
        </div>
      </div>

      <div class="d-flex users-section-container">
        <div class="users-section">
          <span
            >Lista użytkowników
            <!-- <span
              class="icon-collapse"
              data-bs-toggle="collapse"
              href="#userList"
              role="button"
              aria-expanded="true"
              aria-controls="userList"
            ></span -->
          ></span>
        </div>
        <div class="content-wrap">
          <h3>LISTA UŻYTKOWNIKÓW</h3>
          <div class="collapse show" id="userList">
            <UserList />
          </div>
        </div>
      </div>
      <div class="d-flex users-section-container">
        <div class="users-section">
          <span
            >Dodaj użytkownika
            <!-- <span
              class="icon-collapse"
              data-bs-toggle="collapse"
              href="#addUser"
              role="button"
              aria-expanded="true"
              aria-controls="addUser"
            ></span -->
          ></span>
        </div>
        <div class="content-wrap">
          <h3>DANE KONTA</h3>
          <div class="collapse show" id="addUser">
            <AddUser />
          </div>
        </div>
      </div>
      <div class="d-flex users-section-container">
        <div class="users-section">
          <span
            >Historia aktywności użytkowników
            <!-- <span
              class="icon-collapse"
              data-bs-toggle="collapse"
              href="#userHistory"
              role="button"
              aria-expanded="true"
              aria-controls="userHistory"
            ></span -->
          ></span>
        </div>
        <div class="content-wrap">
          <h3>
            HISTORIA AKTYWNOŚCI UŻYTKOWNIKÓW<button
              class="download btn btn-outline-secondary"
              @click="retrieveZip"
              download
            >
              <span
                v-show="isDownloading"
                class="spinner-border spinner-border-sm mr-1"
              ></span>
              POBIERZ
            </button>
          </h3>
          <div class="collapse show" id="userHistory">
            <UserActivityList />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopMenu from "../components/TopMenu.vue";
import UserList from "@/components/UserList";
import UserActivityList from "@/components/UserActivityList";
import AddUser from "@/components/AddUser";
import Users from "@/services/Users";
import moment from "moment";

export default {
  name: "HomeView",
  components: {
    UserActivityList,
    UserList,
    AddUser,
    TopMenu,
  },
  data() {
    return {
      isDownloading: false,
    };
  },
  methods: {
    retrieveZip() {
      this.isDownloading = true;
      const dateFrom = moment().subtract(7, "days").toISOString(false);
      const dateTo = moment().toISOString(false);
      Users.getZip(dateFrom, dateTo)
        .then((data) => {
          Users.fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);
              link.download = "user_logs";
              link.click();
              this.isDownloading = false;
              URL.revokeObjectURL(link.href);
            })
            .catch(console.error);
        })
        .catch((error) => {
          this.loading = false;
          // this.filtersStore.setErrors(error);
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.users-section-container {
  width: 100%;
}

.users-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.users-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

.content-wrap h3 {
  background-color: white;
  padding: 10px 20px;
  font-weight: bold;
  margin-bottom: 0;
  position: relative;
}
h3 button {
  position: absolute;
  right: 30px;
  top: 7px;
  padding: 5px 15px 5px 25px;
}
h3 button::before {
  position: absolute;
  left: 5px;
  top: 5px;
  content: "";
  width: 30px;
  height: 20px;
  background: url("../assets/icons/pobierz.png") no-repeat left top;
}
.no-content {
  min-height: auto;
}
.icon {
  margin: 5px;
  height: 15px;
  width: 35px;
}
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}
</style>
